import Vue from "vue";
import App from "./App.vue";
import Vant from "vant";
import "vant/lib/index.css";
import "@/styles/index.css";
import router from "./router";
import { ToastFail } from "@/utils/common";
Vue.config.productionTip = false;

Vue.use(Vant);

Vue.config.errorHandler = (err, vm, info) => {
  console.error("[Vue Error]", err, info);
  // 可以在这里显示友好的错误提示
  ToastFail("发生错误，请稍后重试");
};

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
